module.exports = __webpack_public_path__ + "static/img/suyang01.babcfc5c.png";